import styled from "styled-components";

export const Container = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;

  border-color: ${({ theme }) => theme.border};
  border-bottom-width: 0.5px;
  border-bottom-style: solid;

  margin-bottom: 15px;
`;

export const Logo = styled.h1`
  color: ${({ theme }) => theme.text};
  font-family: 'Braah One', sans-serif;
  text-transform: uppercase;
  width: max-content;
  padding-top: 10px;

  -webkit-touch-callout: none;
  user-select: none;
`;
